export const environment = {
    apiUrl: 'https://apidev2.digicoffer.com/professional',
    adminApi:'https://adminapi.dev2.digicoffer.com',
    emailApi:"https://dev.utils.mail.digicoffer.com",
    doc2pdf:"https://dev.utils.doc2pdf.digicoffer.com/api/v1/doc2pdf",
    lateXAPI: 'https://devapi.latex.digicoffer.com',
    latexImageFolder: '/home/ubuntu/latekapi/uploads',
    paymentgatway:"https://dev2.payment.digicoffer.com/",
    chatops:' https://dev.utils.chat.digicoffer.com',
    indiaMPURL:'https://devapi.indiamp.digicoffer.com',
    xmppDomain: 'devchat.vitacape.com',
    product: 'lauditor',
    production: true,
  };
 


